import { Component } from 'react'
import { connect } from 'react-redux'
import { createEvent } from 'containers/UserEvents/actions'

const TrackingHOC = (WrappedComponent) => {
  class Tracking extends Component {
    render() {
      const props = { ...this.props }
      return <WrappedComponent {...props} />
    }
  }

  const mapStateToProps = (state) => ({})

  const mapDispatchToProps = (dispatch) => ({
    createEvent: (event) => dispatch(createEvent(event))
  })

  return connect(mapStateToProps, mapDispatchToProps)(Tracking)
}

export default TrackingHOC
